import React, { useState } from "react";
import { clearAllCookies } from "../../../utils";
import { getConfig } from "../../../utils/config";

import HamburgerButton from "./components/HamburgerButton";
import Overlay from "./components/Overlay";
import Nav from "./components/Nav";
import SidebarCollapse from "./components/Nav/SidebarCollapse";
import NavList from "./components/Nav/NavList";
import MenuLabel from "./components/Nav/MenuLabel";
import LogoutButton from "./components/Nav/LogoutButton";
import Hr from "./components/Nav/Hr";

import NavHeader from "./components/SideArea/SideHeader";
import SideMenu from "./components/SideArea/SideMenu";

const config = getConfig();

export default (props) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    clearAllCookies();
    localStorage.clear();
    window.location.href = config.login.logoutRedirect || "/";
  };

  return (
    <React.Fragment>
      <HamburgerButton setMenuOpen={setMenuOpen} menuOpen={menuOpen} />

      <Overlay open={menuOpen} onClick={() => setMenuOpen(false)} />

      <Nav open={menuOpen}>
        <SidebarCollapse>
          <NavList>
            <NavHeader />
            <SideMenu />

            <Hr />

            <MenuLabel>
              <LogoutButton onClick={handleLogout}>
                <i className="fas fa-sign-out-alt" />
                <span>Sair</span>
              </LogoutButton>
            </MenuLabel>
          </NavList>
        </SidebarCollapse>
      </Nav>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Sidebar/index.jsx